import React from "react";

function DeFiStakingByXeer() {
  return (
    <div className="about-area pt-5 pb-5 default-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5 text-center">
            <div className="thumb">
              <img
                src="/assets/img/illustration/2.png" // placeholder
                alt="Ethereum Staking"
                style={{ maxWidth: "100%" }}
              />
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1">
            <div className="">
              <h2
                className="title split-lines mb-4"
                style={{ fontWeight: "bold" }}
              >
                DeFi Staking Platform Development by Xeer Technology
              </h2>
              <p style={{ fontSize: "16px", color: "#555" }}>
                Xeer Technology is a prestigious innovator for secure and
                modular DeFi staking platform development. We engineer scalable
                ecosystems equipped to handle colossal transaction volumes
                seamlessly. Our platforms bring robust smart contract
                architectures and uncompromised scalability to your protocol,
                cultivating a highly rewarding staking environment to catalyze
                the ultimate Web3 revolution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeFiStakingByXeer;
